// ======================================================================
// File Name       : DialogConfirm
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Button, Modal } from 'react-bootstrap';

class DialogConFirmView extends React.Component {
  render() {
    const style = {
      background: 'none',
      width: 'auto',
      marginLeft: 0,
      left: 0,
    };
    return (
      <Modal
        className="modal-container"
        show={this.props.showModal}
        onHide={this.props.onCancel && this.props.onCancel}
        size={this.props.mdSize}
        animation={this.props.animation}
        style={style}
        dialogClassName={this.props.className}
      >
        {this.props.title &&
        <Modal.Header onHide={this.props.onCancel} closeButton>
          <Modal.Title className="text-center">
            {this.props.title}
          </Modal.Title>
        </Modal.Header>
        }
        <Modal.Body className={!this.props.leftContent && 'text-center'}>
          {this.props.content}
        </Modal.Body>

        <Modal.Footer className="text-center">
          {this.props.onCancel &&
            <Button variant="default" className=" margin-right-10 btn btn-default btn-96" onClick={this.props.onCancel}>
              キャンセル
            </Button>}
          <Button variant="primary" className=" margin-left-10 btn-96" onClick={this.props.onOK}>
            OK
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

DialogConFirmView.defaultProps = { animation: true };
export default DialogConFirmView;
